import { ACTION } from "../../util/utils";
import { KEYS, MODULE_KEY, FETCH_ECOM_SHIPPING, FETCH_ECOM_SHIPPING_SUCCESS, FETCH_ECOM_SHIPPING_FAILED } from "./ecomOrders-actions";

export const REDUCER_KEY = KEYS[MODULE_KEY + ACTION.STATE_KEY];

export interface IEcomOrdersState {
  loading: boolean;
  error: any;
  data: [];
  shippingConfig: {
    loading: boolean;
    data: any[];
    error: any;
  };
}

const defaultState: IEcomOrdersState = {
  loading: false,
  error: null,
  data: [],
  shippingConfig: {
    loading: false,
    data: [],
    error: null,
  },
};

export const ecomOrdersReducer = (
  state = defaultState,
  { type, payload }: any
) => {
  switch (type) {
    case KEYS[MODULE_KEY + ACTION.FETCH]:
      return {
        ...state,
        loading: true,
      };
    case KEYS[MODULE_KEY + ACTION.SUCCESS]:
      return {
        ...state,
        loading: false,
        data: [...payload],
      };
    case KEYS[MODULE_KEY + ACTION.FAILED]:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    case FETCH_ECOM_SHIPPING:
      return {
        ...state,
        shippingConfig: {
          ...state.shippingConfig,
          loading: true,
        },
      };
    case FETCH_ECOM_SHIPPING_SUCCESS:
      return {
        ...state,
        shippingConfig: {
          loading: false,
          data: payload,
          error: null,
        },
      };
    case FETCH_ECOM_SHIPPING_FAILED:
      return {
        ...state,
        shippingConfig: {
          ...state.shippingConfig,
          loading: false,
          error: payload,
        },
      };

    default:
      return state;
  }
};
